/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { StyledTextInput } from '../StyledTextInput';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledTextarea = StyledTextInput.withComponent('textarea').extend`
  resize: vertical;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledTextarea/index.js